<ng-container *ngIf="editMode">
  <p-skeleton height="32px" [width]="minWidth" styleClass="skeleton-with-border" *ngIf="!categoriesLoaded"></p-skeleton>
  <p-dropdown
    scrollHeight="400px"
    inputId="categoriesDropdown{{ guid }}"
    name="categoriesDropdown{{ guid }}"
    [options]="categories"
    [(ngModel)]="_categorie"
    [required]="required"
    [disabled]="disabled"
    dataKey="Id"
    [showClear]="showClear"
    [resetFilterOnHide]="true"
    [emptyFilterMessage]="'Aucun résultat'"
    appendTo="body"
    [placeholder]="placeholder"
    emptyMessage="Aucun résultat trouvé"
    [autoDisplayFirst]="false"
    [style]="pDropdownStyle"
    #categorieCtrl="ngModel"
    (ngModelChange)="categorieChanged()"
    *ngIf="categoriesLoaded"
    styleClass="no-ellipsis"
    (onFocus)="inputFocusChanged(inputFocusValue);"
    (onBlur)="inputFocusChanged(null)"
  >
    <ng-template let-item pTemplate="selectedItem">
      <span>{{ item?.Nom }}</span>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="ui-helper-clearfix">
        <span>{{ item.Nom }}</span>
      </div>
    </ng-template>
  </p-dropdown>
</ng-container>
<ng-container *ngIf="_categorie && !editMode">
  <span>{{ _categorie.Nom }}</span>
</ng-container>
